export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Z"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kwota"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przelej"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przelew między własnymi kontami"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przelewy w portfelu"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konta nadawcy i odbiorcy muszą być różne"])}
}